import global from "./global/global.js";
import notifications from "./global/notifications.js";
import dotDotDot from "./jquery.dotdotdot-wrapper.js";
import viewHelpers from "./view_helpers.js";

/**
 * global watchers/observers
 */
$("body").ready(() => {
	pp.vue.bus.$on("game-actors-UPDATE", setOnlineRecipients);

	// listen for changes on 'send message on enter' click
	$(document).on(
		"click",
		"#message_send_on_enter, #chat_messages_attributes_0_send_on_enter",
		function () {
			$(this).parent().siblings().toggleClass("hidden", !this.checked);
			$(this)
				.closest("form")
				.find("button")
				.toggleClass("hidden", this.checked);
			pp.sendMessagesOnEnter = this.checked;
		},
	);

	if (!$("body").hasClass("moderator-view")) {
		initAdjustChatSizeListeners();
	}
});

const minHeight = 400;

/**
 * Global caller to init Chat functions, to be invoked on every page with all Chat functionalities (i.e. Chats overview, new Chat form etc.)
 */
function initChatModule() {
	// Hide pagination links and set listener for scrollbottom
	chat.messageOverview = $(".ChatsOverview__list");
	global.autoloadPagination(chat.messageOverview);

	// Ellipsis for Chat preview
	$(document).on("bootstrap:breakpoint-changed", () => {
		if (!chat.messageOverview?.is(":visible")) {
			return;
		}
		dotDotDot.set(chat.messageOverview.find("p"));
	});

	// dotdotdot doesn't work on hidden elements. This will only fire when `initChatModule` is called from an individual Chat, not the Chats index
	$(".Chat__inbox-toggle").one("shown.bs.tab", () => {
		dotDotDot.set(chat.messageOverview?.find("p"));
	});

	// New message click - toggles the "tabs" on smaller screens if there is someone switching between a new message form and the inbox
	$(".j-chats-form-link").on("click", () => {
		const $messageForm = $(".ChatMessageForm");
		if ($messageForm.length && !$messageForm.is(":visible")) {
			$("#messages-empty-placeholder").addClass("hidden");
			$(".ChatMessageForm").removeClass("hidden");
			$(".ChatsContentContainer, .ChatsOverview").toggleClass("active"); // The parent of `.ChatMessageForm`
			return false; // Avoid loading the form via AJAX
		}
	});

	/**
	 * Set the observer for the message overview box
	 */
	chat.messageOverview.observe().on("insertNode", (event, el) => {
		dotDotDot.set($(el).find("p"));
		$(el).find("time[data-time-ago]").timeago();
		if ($("#ChatsOverview__placeholder").length) {
			// if there has been no chat in the overview
			$("#ChatsOverview__placeholder").remove(); // remove the placeholder
			// check if there is no current chat (there will be one for the actor who created it) and no visible chat form
			if (
				chat.currentChat === undefined &&
				!$(".ChatMessageForm:visible").length
			) {
				$(el).trigger("click"); // Open link to chat
			}
		}
	});
}

/**
 * init a single chat
 * @param {number | string} id database ID of this chat, used for the jQuerey selector
 * @param {JQuery} $chatElem
 * @param {boolean} [moderatorsView]
 */
function initNewChat(id, $chatElem, moderatorsView = false) {
	chat.currentChat = $chatElem; // The class selector is only used in the mod area

	// Set current Chat link in overview active
	$(".ChatsOverview__list").find("a.active").removeClass("active");
	// ark Chat as active and remove blue 'new' bar in the menu
	$(".ChatsOverview__list")
		.find(`a[data-chat-id='${id}']`)
		.addClass("active")
		.find("div.is-new-message")
		.remove();

	// set timeago for loaded messages
	chat.currentChat.find("time[data-time-ago]").timeago();

	// ellipsis for Chat Messages
	dotDotDot.set(chat.currentChat.find(".ChatMessage__message-content"), true);

	// set online Actors for Chat
	setOnlineRecipients();

	// add insert observer
	chat.currentChat.observe().on("insertNode", handleInsertedNode);

	global.autoloadPagination(chat.currentChat);

	$(document).on("bootstrap:breakpoint-changed", () => {
		// Don't fit the Chats in the mod area to the window
		// In a responsive page whith an embedded / predefined members chat, we don't want to apply the resize logic
		const noAutoResizeChat =
			moderatorsView ||
			(viewHelpers.isBreakpointOfSize("xs") &&
				chat.currentChat?.is(
					".ChatMessageContainer--key-group, .ChatMessageContainer--key-market_square",
				));
		if (noAutoResizeChat) {
			chat.currentChat?.removeAttr("style");
		}
		chat.currentChat?.toggleClass("j-no-autoresize", Boolean(noAutoResizeChat));
		if (!noAutoResizeChat) {
			handleResize();
		}
	});

	setTimeout(() => {
		if (chat.currentChat === undefined) {
			return;
		}
		chat.currentChat.scrollTop(chat.currentChat.get(0)?.scrollHeight ?? 0);
		if (!moderatorsView && chat.currentChat.attr("style") === undefined) {
			handleResize(); // Trigger once if it has not been triggered otherwise (happens on full page load)
		}
	}, 500);

	initPreventSpamming();

	if (!moderatorsView) {
		initActivityNotification(id);
		viewHelpers.initSimpleInlineTextForm();
		chat.currentChat.on("destroyed destroyed_proxy", (event) => {
			handleDestroyedChat(event, id);
		});
	}

	initFlaggedStatusListener(chat.currentChat.children("div.ChatMessage"));
}

/**
 * Initialize JS for the new Chat form
 * @param {boolean} [clearCheckboxes]
 */
function initForm(clearCheckboxes) {
	if (clearCheckboxes) {
		// Set all recipient boxes to unchecked in case browser has stored values
		setRecipientBoxes($(".j-recipient"), false, true);
	}

	// Check single recipient box for new chat
	$("div.j-recipient").on("click", function ({ currentTarget }) {
		const isGroup = $(currentTarget).hasClass(
			"actorsOverview-groupHeader-select",
		);

		setRecipientBoxes(this, isGroup);

		$("#chat_actor_id").attr(
			"value",
			isGroup
				? VueStore.getters.actorData(pp.currentActorId).principalGroupId
				: pp.currentActorId,
		);
	});
}

/**
 * @param {JQuery.TriggeredEvent} event
 * @param {HTMLElement} el
 */
function handleInsertedNode(event, el) {
	if (el.textContent.trim().length === 0) {
		// for some reason bootstrap inserts empty text nodes (only in moderator's area)
		return;
	}

	$("#messages-placeholder").remove();
	const $el = $(el);

	const $actorOnlineStatus = $el.find(".ChatMessage__actor-online-status");
	if (typeof VueStore !== "undefined" && $actorOnlineStatus.length) {
		// only if it's not a deleted message elem
		const actorId = $actorOnlineStatus.data("actorId");

		$actorOnlineStatus.html("<span class='circle-offline'></span>");
		if (VueStore.getters.actorData(actorId).isOnline) {
			setOnlineSingleRecipient($actorOnlineStatus);
		}
	}
	$el.find("time[data-time-ago]").timeago();

	// ellipsis for chat messages
	dotDotDot.set($el.find("div > p"), true);

	// remove new forced classes from message after 5 seconds
	if ($el.hasClass("new forced")) {
		setTimeout(() => {
			$el.removeClass("new forced");
		}, 5000);
	}

	if (chat.currentChat !== undefined) {
		const scrollBottom =
			// @ts-expect-error
			chat.currentChat.scrollTop() +
				// @ts-expect-error
				chat.currentChat.height() +
				// @ts-expect-error
				$el.outerHeight() >=
			// @ts-expect-error
			chat.currentChat[0].scrollHeight -
				// @ts-expect-error
				$(".ChatActivityNotification:visible").height() -
				5; // Give 5px leeway
		if (scrollBottom) {
			scrollToBottom(250);
		}
	}

	// remove the sender's id from the list of currently typing subscribers immediately (assume that they stopped typing)
	// only if this new element has been inserted at the very bottom (i.e. from a feed and not from pagination)
	const $onlineStatusEl = $el.find(".ChatMessage__actor-online-status");
	if (
		$onlineStatusEl.length &&
		$el.parent().children(".ChatMessage").last().is($el)
	) {
		const actorId = $onlineStatusEl.data("actorId").toString();
		clearTimeout(activeSubscribersData[actorId]);
		delete activeSubscribersData[actorId];
		composeActivityNotification();
	}

	initFlaggedStatusListener($el);
}

/**
 * Set html checkboxes for recipients in new Chat form to checked or unchecked and mark them with (background)color
 * @param {HTMLElement | JQuery} field selector for the elements
 * @param {boolean} isGroup determines whether this is a group or single actor field
 * @param {boolean} [checked] the current checked status of the boxes which will be inverted here
 */
function setRecipientBoxes(field, isGroup, checked) {
	const $field = $(field);
	const $fieldsGroup = $field.parents("div.actorsOverview-group");

	if (checked === undefined) {
		checked = isGroup
			? $fieldsGroup.hasClass("checked")
			: $field.hasClass("checked");
	}

	$field.find("input").prop("checked", !checked);

	if (checked) {
		$field.removeClass("checked");
		if (isGroup) {
			$field.closest("div.actorsOverview-group").removeClass("checked");

			if (
				!$field
					.closest("div.actorsOverview-group")
					.find("div.actorsOverview-actor.checked").length
			) {
				return;
			}
			setRecipientBoxes(
				$field
					.closest("div.actorsOverview-group")
					.find("div.actorsOverview-actor.checked"),
				false,
				true,
			);
		} else {
			// Check if a single Actor from a group has been unselected when the whole group was selected.
			// In this case, unselect the group, but keep the other single actors selected
			if (
				!$field
					.closest("div.actorsOverview-group")
					.find("div.actorsOverview-actor.checked").length
			) {
				// Remove the 'checked' highlighting from the group
				$fieldsGroup.removeClass(
					"checked checked--entirely checked--partially",
				);
				return;
			}
			$fieldsGroup
				.removeClass("checked--entirely")
				.addClass("checked checked--partially");
			$fieldsGroup
				.find("div.actorsOverview-groupHeader-select")
				.removeClass("checked");
			$fieldsGroup
				.find(".actorsOverview-groupHeader input")
				.prop("checked", false);
			setRecipientBoxes(
				$field
					.closest("div.actorsOverview-group")
					.find("div.actorsOverview-actor.checked"),
				false,
				false,
			);
		}
		return;
	}

	$field.addClass("checked");
	if (isGroup) {
		if ($field.parents(".actorsOverview-groupHeader").hasClass("collapsed")) {
			$field.parents(".actorsOverview-groupHeader").trigger("click");
		}
		// force uncheck of all single recipient boxes that are _actually_ checked
		$("div.actorsOverview-actor.checked").each((_, elem) => {
			const $elem = $(elem);
			if ($elem.find("input").prop("checked")) {
				$elem.removeClass("checked");
				$elem.find("input").prop("checked", false);
				$elem
					.closest("div.actorsOverview-group")
					.removeClass("checked checked--partially");
			}
		});
		$fieldsGroup
			.addClass("checked checked--entirely")
			.removeClass("checked--partially");
		$fieldsGroup.find("div.actorsOverview-actor").addClass("checked");
		return;
	}
	$fieldsGroup
		.addClass("checked checked--partially")
		.removeClass("checked--entirely");
	// If this is a newly checked single Actor, disable all the checked groups, but keep their group members checked
	$("div.actorsOverview-groupHeader-select.checked").each(function () {
		const $this = $(this);
		// Check if the group group is actually checked
		if ($this.find("input").prop("checked")) {
			setRecipientBoxes(this, true);
			setRecipientBoxes(
				$this
					.closest("div.actorsOverview-group")
					.find("div.actorsOverview-actor"),
				false,
				false,
			);
		}
	});
}

/**
 * set online status for chat recipients
 */
function setOnlineRecipients() {
	if (chat.currentChat === undefined) {
		return;
	}

	const gameActors = VueStore.getters.gameActors();
	const onlineActors = Object.entries(gameActors).filter(
		([, actorItem]) => actorItem.isOnline == true,
	);

	// Reset all
	$(".ChatMessage__actor-online-status").html(
		"<span class='circle-offline'></span>",
	);
	onlineActors.forEach(([actorId]) => {
		setOnlineSingleRecipient(
			$(`.ChatMessage__actor-online-status[data-actor-id='${actorId}']`),
		);
		setOnlineSingleRecipient(
			$(
				`.ChatMessage__actor-online-status[data-actor-id='${gameActors[actorId].principalGroupId}']`,
			),
		);
	});
}

/**
 * set a single Chat recipient online
 * @param {JQuery} onlineStatusEl
 */
function setOnlineSingleRecipient(onlineStatusEl) {
	onlineStatusEl.html("<span class='circle-online'></span>");
}

let spamLastMessageTimes = [];
const spamThreshold = 8000;
const spamDelay = 10000;
const spamRedeemerDelay = 5000;
let spamCurrentDelay = 0;
let spamTimeout;
let spamRedeemer;

/**
 * observe the interval with which users send messages and disabled the send button for some seconds after a given threshold is reached
 */
function initPreventSpamming() {
	spamLastMessageTimes = []; // reset
	$(".ChatMessageForm")
		.find("button[type=submit]")
		.on("click", ({ target }) => {
			if ($(target).prop("disabled") == true) {
				return;
			}
			const now = Date.now();
			if (
				spamTimeout !== undefined ||
				(spamLastMessageTimes.length > 1 &&
					spamLastMessageTimes[0] + spamThreshold > now)
			) {
				setSpamDelay(target);
				spamLastMessageTimes = [];
			} else {
				if (spamLastMessageTimes.length > 1) {
					spamLastMessageTimes = [];
				}
				spamLastMessageTimes.push(now);
			}
		});
}

/**
 * @param {HTMLElement} button
 */
function setSpamDelay(button) {
	clearTimeout(spamRedeemer); // if there's a redeemer waiting, disable it

	$(button)
		.closest("form")
		.one("ajax:complete", () => {
			// wait until the confirm for the last sent message has arrived
			setTimeout(() => {
				$(button).prop("disabled", true);
			}, 5);

			$(button)
				.siblings("textarea")
				.prop("disabled", true)
				.val(I18n.t("chats.spam_protection_active"));
		});
	spamCurrentDelay = Math.min(spamCurrentDelay + spamDelay, 60000);

	spamTimeout = setTimeout(() => {
		$(button).prop("disabled", false);
		$(button).siblings("textarea").prop("disabled", false).val("");
		redeemSpamDelay();
	}, spamCurrentDelay);
}

function redeemSpamDelay() {
	spamRedeemer = setTimeout(() => {
		spamCurrentDelay = 0;
		spamTimeout = undefined;
	}, spamRedeemerDelay);
}

const limiterDelay = 30000;
let limiterLockedChatId;
let limiterStartTime;
let limiterInterval;
let limiterTimeout;

/**
 * Force a 30s gap between sending two Chat messages (only used for the market_square_chat in communal games)
 */
function initMessageLimiter() {
	$(".ChatMessageForm").find("form").on("submit", lockForm);

	// prevent users from circumventing the limiter by navigating away from and returning to the chat
	if (limiterLockedChatId == chat.currentChat?.attr("id")) {
		disableFields();
	}
}

function lockForm() {
	limiterStartTime = Date.now();
	limiterLockedChatId = chat.currentChat?.attr("id");

	limiterInterval = setInterval(() => {
		// avoid updating the timer for other chats
		if (limiterLockedChatId != chat.currentChat?.attr("id")) {
			return;
		}

		const percent =
			100 - ((Date.now() - limiterStartTime) / limiterDelay) * 100;
		updateTimerCss(percent);
	}, 50);

	$(".ChatMessageForm")
		.find("form")
		.one("ajax:complete", () => {
			// wait until the confirm for the last sent message has arrived
			setTimeout(disableFields, 10);
		});

	limiterTimeout = setTimeout(() => {
		updateTimerCss(0);
		$(".ChatMessageForm").find("button").prop("disabled", false);
		$(".ChatMessageForm").find("textarea").prop("disabled", false).val("");
		limiterTimeout = undefined;
		limiterLockedChatId = undefined;
	}, limiterDelay);
}

function disableFields() {
	$(".ChatMessageForm").find("button").prop("disabled", true);
	$(".ChatMessageForm")
		.find("textarea")
		.prop("disabled", true)
		.val(I18n.t("chats.wait_for_next_message"));
}

/**
 * @param {number} percent
 */
function updateTimerCss(percent) {
	$(".ChatMessageForm").find("div.timer-bar").css("width", `${percent}%`);
}

/**
 * notify the other users of the pad that this one is active
 * @param {string} url
 */
function notifyActivity(url) {
	// @ts-expect-error
	if (PrivatePub.fayeClient) {
		// @ts-expect-error
		PrivatePub.fayeClient.publish(url, {
			data: { actorId: pp.currentActorId },
		});
	}
}

const activityGracetime = 3000;
const activityRefreshInterval = 2000;
const activeSubscribersData = {};
let activityInterval;

/**
 * subscription to chat's activity notification channel and listen to actions by the user
 * @param {number | string} chatId
 */
function initActivityNotification(chatId) {
	// custom subscribe with callback
	PrivatePub.subscribe(`/chats/${chatId}`, (data) => {
		if (pp.currentActorId === undefined || data.actorId == pp.currentActorId) {
			return; // Ignore incoming from the same Actor
		}

		if (data.type == "unsubscribed") {
			// delete instantly and return
			delete activeSubscribersData[data.actorId];
			return;
		}

		clearTimeout(activeSubscribersData[data.actorId]);
		activeSubscribersData[data.actorId] = setTimeout(() => {
			delete activeSubscribersData[data.actorId];
		}, activityGracetime);

		/*
		 * only execute this now so that keys can be pushed to activeSubscribersData
		 * only trigger this if there is no interval yet in order to avoid flickering of the text
		 * if many people start typing almost at the same time
		 */
		if (activityInterval === undefined) {
			composeActivityNotification(); // trigger this instantly now
			activityInterval = setInterval(
				composeActivityNotification,
				activityRefreshInterval,
			);
		}
	});

	$("#message_content").on("keyup", ({ keyCode, currentTarget }) => {
		// check if the user hasn't just skipped through fields with tab and if there is any content in the textarea
		// @ts-expect-error
		if (keyCode != 9 && currentTarget.value.length != 0) {
			notifyActivity(`/chats/${chatId}`);
		}
	});
}

/**
 * Show who is typing at the moment
 */
function composeActivityNotification() {
	const activeActorsNames = [];
	$.each(activeSubscribersData, (id) => {
		const actor = VueStore.getters.actorData(id);
		if (actor !== undefined) {
			const names = actor.names;
			activeActorsNames.push(names[I18n.locale] || Object.values(names)[0]);
		}
	});
	if (activeActorsNames.length) {
		if (chat.currentChat === undefined) {
			return;
		}
		const $notificationWrapper = chat.currentChat.find(
			".ChatActivityNotification",
		);
		const scrollBottom =
			// @ts-expect-error
			chat.currentChat.scrollTop() + chat.currentChat.outerHeight() >=
			// @ts-expect-error
			chat.currentChat[0].scrollHeight - 5; // give 5px leeway
		$notificationWrapper.show().find("div").html(activeActorsNames.join(", "));
		if (scrollBottom) {
			scrollToBottom(150);
		}
	} else {
		chat.currentChat?.find(".ChatActivityNotification").removeAttr("style");
		clearInterval(activityInterval);
		activityInterval = undefined;
	}
}

/**
 * @param {number} animationMs
 */
function scrollToBottom(animationMs) {
	if (chat.currentChat === undefined) {
		return;
	}
	chat.currentChat.animate(
		{
			// @ts-expect-error
			scrollTop: chat.currentChat[0].scrollHeight,
		},
		animationMs,
	);
}

/* Make sure that the Chat Messages window is always so big that it fills the page to the bottom, but never shorter than 450px */
let focusInTimestamp = null;
let onscreenKeyboardHeight = 0;
let windowHeightBeforeKeyboard;
function initAdjustChatSizeListeners() {
	$(window).on("resize", _.debounce(handleResize, 150));
	$(window).on("scroll", detectOnscreenKeyboardAutoScroll);
	// For some reason this only gets executed instantly (i.e. the Chat's height gets adjusted right away)
	// when the listener is declared after 'page:change'
	$(document).on("page:change", () => {
		$(".ChatMessageForm textarea").on("input", handleResize);
		$(".ChatMessageForm textarea").on("focusin", handleFocusIn);
		$(".ChatMessageForm textarea").on("focusout", handleFocusOut);
	});
}

// Prime the `detectOnscreenKeyboardAutoScroll` handler: If the current Chat is the only (visible) element on the page, and the Message textarea is being focused:
// Wait for a scroll event, which presumably comes from the page automatically scrolling when the onscreen keyboard opens
function handleFocusIn() {
	// For when composing a new Chat
	if (chat.currentChat === undefined) {
		return;
	}
	const $parentModule = chat.currentChat.closest(".Module");
	if (
		$(window).scrollTop() != 0 ||
		// @ts-expect-error
		($parentModule.attr(pp.tabbedModules.tabSortOrderAttr) === undefined &&
			!$parentModule.hasClass("Module--sole-on-page"))
	) {
		return;
	}
	windowHeightBeforeKeyboard = window.innerHeight;
	focusInTimestamp = Date.now();
}

function handleFocusOut() {
	// For when composing a new Chat
	if (chat.currentChat === undefined) {
		return;
	}
	const $parentModule = chat.currentChat.closest(".Module");
	if (
		// @ts-expect-error
		$parentModule.attr(pp.tabbedModules.tabSortOrderAttr) === undefined &&
		!$parentModule.hasClass("Module--sole-on-page")
	) {
		return;
	}
	onscreenKeyboardHeight = 0;
	handleResize();
}

function detectOnscreenKeyboardAutoScroll() {
	const now = Date.now();
	if (chat.currentChat === undefined || now > focusInTimestamp + 1000) {
		return;
	}
	// @ts-expect-error
	onscreenKeyboardHeight = $(window).scrollTop();
	focusInTimestamp = 0; // Already reset now so that `$(window).scrollTop(0)`in `handleResize` won't trigger this function again
	handleResize();
}

function handleResize() {
	// Don't do anything if there is no current Chat or it's the market square chat
	if (
		chat.currentChat === undefined ||
		chat.currentChat.hasClass("j-no-autoresize")
	) {
		return;
	}
	chat.currentChat.css("height", 0);

	let availableWindowHeight = window.innerHeight; // will return `null` if currently not visible

	const moduleBottomMargin = parseInt(
		chat.currentChat.closest(".Module").css("margin-bottom"),
		10,
	);
	let bottomNavHeight = $(".BottomNav__main-nav:visible").outerHeight() || 0;
	if (
		// @ts-expect-error
		$("body").height() > availableWindowHeight &&
		viewHelpers.isBreakpointOfSize(">sm")
	) {
		// @ts-expect-error
		availableWindowHeight = $("body").height();
	}

	if (onscreenKeyboardHeight != 0) {
		availableWindowHeight = Math.min(
			window.innerHeight,
			windowHeightBeforeKeyboard - onscreenKeyboardHeight,
		);
		// @ts-expect-error
		if ($(".BottomNav__main-nav").offset().top > availableWindowHeight) {
			bottomNavHeight = 0; // Will not be visible because it's behind the keyboard
		}
		$(window).scrollTop(0);
		scrollToBottom(150);
	}

	let targetHeight =
		availableWindowHeight -
		// @ts-expect-error
		chat.currentChat.offset().top -
		// @ts-expect-error
		chat.currentChat.siblings(".ChatFooter").outerHeight() -
		bottomNavHeight -
		moduleBottomMargin;

	if (onscreenKeyboardHeight == 0) {
		targetHeight = Math.max(targetHeight, minHeight);
	}

	chat.currentChat.css("height", `${targetHeight}px`);
}

/**
 * Listen for clicks on the flag/unflag clicks
 * @param {JQuery} $elems
 */
function initFlaggedStatusListener($elems) {
	$elems.each(function () {
		const $elem = $(this);
		$elem.find("div.status-options a.j-flag-link").on("click", (event) => {
			event.preventDefault();
			const $target = $(event.currentTarget);
			// Deterine whether the Actor or the Actor's principal group (for group Chats) has already flagged by their name
			const currentActor = VueStore.getters.actorData(pp.currentActorId);
			const currentActorPrincipalGroupId = currentActor.principalGroupId;
			let containsQuery = `div:contains(${currentActor.names[I18n.locale]})`;
			containsQuery += `, div:contains(${VueStore.getters.actorData(currentActorPrincipalGroupId).names[I18n.locale]})`;
			if (
				$target.siblings(".OverlayContainer__content").find(containsQuery)
					.length
			) {
				handleClickSubmit($target);
			} else {
				handleModalFormOpen($target);
			}
			return false;
		});
	});
}

/**
 * @param {JQuery} $target
 */
function handleModalFormOpen($target) {
	const $modal = $("#flag-message-modal");
	$modal
		.find(".j-flag-message-owner")
		.html(
			$target
				.closest("div.ChatMessage")
				.find("div.ChatMessage__actor-name")
				.text(),
		);
	// Clone and remove the "read more" child before getting the message text
	$modal
		.find(".j-flag-message-text")
		.html(
			$target
				.closest("div.ChatMessage")
				.find("div.ChatMessage__message-content")
				.clone()
				.children()
				.remove()
				.end()
				.text(),
		);
	$modal
		.modal("show")
		.find("form")
		.attr("action", /** @type {string} */ ($target.attr("href")));
	$modal.find("form").validate();
	$modal
		.find("form")
		.off("submit")
		.on("submit", (event) => {
			event.preventDefault();
			const $form = $(event.currentTarget);
			$form.find("button").prop("disabled", true);
			$.ajax({
				url: $form.attr("action"),
				type: "PUT",
				dataType: "json",
				data: $form.serialize(),
			}).done((data) => {
				$modal.modal("hide");
				// @ts-expect-error
				$form[0].reset();
				$form.find("button").prop("disabled", false);
				setFlaggedStatusAndOverlay($target, data);
			});
			return false;
		});
}

/**
 * @param {JQuery} $target
 */
function handleClickSubmit($target) {
	$.ajax({
		url: $target.attr("href"),
		type: "PUT",
		dataType: "json",
	}).done((data) => {
		setFlaggedStatusAndOverlay($target, data);
	});
}

/**
 * @param {JQuery} $target
 * @param {{status: string, message: string, flagged_by_ids: number[]}} response
 */
function setFlaggedStatusAndOverlay(
	$target,
	{ status, message, flagged_by_ids },
) {
	const messageId = $target.closest(".ChatMessage").attr("data-message-id");
	$target.siblings(".OverlayContainer__content").find("span").html(message);

	// Expect only 'unprocessable'
	if (status != "ok") {
		notifications.display("error", message);
		return;
	}

	pp.vue.bus.$emit("actor-list-items-UPDATE", {
		identifier: `message-flaggers-${messageId}`,
		actorIds: flagged_by_ids,
	});

	// Use the flagged_by_ids to determine whether the message is still flagged
	if (flagged_by_ids.length) {
		$target
			.children("span")
			.addClass("senaryon-icon senaryon-icon-flag")
			.removeClass("glyphicon glyphicon-exclamation-sign")
			.show(); // Make sure that the flag is always visible
	} else {
		$target
			.children("span")
			.removeClass("senaryon-icon senaryon-icon-flag")
			.addClass("glyphicon glyphicon-exclamation-sign");
	}
}

/**
 * register listener for chat message textarea to submit form on enter or add a line break of shift or ctrl are pressed
 */
function sendMessagesOnEnterListener() {
	$(document).on("keydown", "textarea.form-control", (e) => {
		if (e.keyCode != 13) {
			return;
		} // enter not pressed, no need to do anything

		const target = e.target;
		const isMessageField = [
			"message_content",
			"chat_messages_attributes_0_content",
		].includes(target.id);

		if (e.ctrlKey) {
			if (!pp.sendMessagesOnEnter && isMessageField) {
				$(target).closest("form").find("button[type=submit]").trigger("click");
				return false;
			}

			const val = target.value;
			if (
				typeof target.selectionStart === "number" &&
				typeof target.selectionEnd === "number"
			) {
				const start = target.selectionStart;
				target.value =
					val.slice(0, start) + "\n" + val.slice(target.selectionEnd);
				target.selectionStart = target.selectionEnd = start + 1;
				// @ts-expect-error
			} else if (document.selection && document.selection.createRange) {
				target.focus();
				// @ts-expect-error
				const range = document.selection.createRange();
				range.text = "\r\n";
				range.collapse(false);
				range.select();
			}
		}
		// only if send messages on enter is enabled AND this form-control elem is for a chat message
		else if (pp.sendMessagesOnEnter && isMessageField) {
			if (
				target.value.trim() ===
					I18n.t("messages.new_message_placeholder").trim() ||
				target.value === ""
			) {
				target.value = "";
				e.preventDefault();
				return false;
			}

			e.preventDefault();
			$(target).closest("form").find("button[type=submit]").trigger("click");

			return false;
		}
	});
}

/**
 * @param {number} messageId
 * @param {string} messageHtml
 */
function replaceMessageContent(messageId, messageHtml) {
	if (chat.currentChat === undefined) {
		return null;
	}
	const $message = chat.currentChat.find(
		`.ChatMessage[data-message-id=${messageId}]`,
	);
	if (!$message.length) {
		return null;
	}

	global.securelyReplaceDOMElemContent(
		$message,
		$(messageHtml).html(),
		$(messageHtml).attr("class"),
	);
	// Trigger timeago setting and truncation manually, securelyReplaceDOMElemContent will not do this
	chat.currentChat.trigger("insertNode", $message); // Trigger online status and timeago setting manually
	return $message;
}

/**
 * @param {string} chatUrl
 * @param {string} previewHtml
 * @param {boolean} [requirePresentPreviewContainer] is only used from the ghost Actors portion in messages/create_feed to
 * 	prevent inserting of new Chat previews in `.ChatsOverview__list` containers of Actors that are not recipients of the given Chat
 */
function detachAndInsertNewChatPreview(
	chatUrl,
	previewHtml,
	requirePresentPreviewContainer = false,
) {
	// For the frontend there should only ever be one `.ChatsOverview__list`, only in t he mod area should we have multiple lists
	$(".ChatsOverview__list").each((index, elem) => {
		const $container = $(elem);
		const $messagePreviewContainer = $container.find(`a[href='${chatUrl}']`);

		if (!$messagePreviewContainer.length) {
			// if none present, just prepend the new html to the overview
			if (!requirePresentPreviewContainer) $container.prepend(previewHtml);
			return;
		}

		const $detached = $messagePreviewContainer.detach();
		$detached.html($(previewHtml).html());
		$container.prepend($detached);
		pp.vue.mountElementsInContainer($detached);
	});
}

/**
 * @param {JQuery.TriggeredEvent} event
 * @param {number | string} id
 */
function handleDestroyedChat(event, id) {
	if (event.target != chat.currentChat?.[0]) {
		return;
	}
	// @ts-expect-error
	PrivatePub.deleteNonFeed(`/chats/${id}`, "Chat destroyed");
	clearInterval(activityInterval);
	activityInterval = undefined;
	chat.currentChat = undefined;
}
const chat = {
	/** @type {JQuery | undefined} */
	currentChat: undefined,
	/** @type {JQuery | undefined} */
	messageOverview: undefined,
	initChatModule,
	initNewChat,
	initForm,
	sendMessagesOnEnterListener,
	replaceMessageContent,
	detachAndInsertNewChatPreview,
	activityNotification: { init: initActivityNotification },
	messageLimiter: { init: initMessageLimiter },
};

export default chat;
